import { TranslateModule } from '@ngx-translate/core';
import { IBookingModel } from '@services/api/booking/booking-model.interface';
import { LogService } from '@services/util/log.service';
import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BookingActionEvent } from '../../models/booking-detail.model';
import { BookingChangeTrackerService } from '../../services/booking-change-tracker.service';
import { BookingRoomDisplayComponent } from '../booking-room-display/booking-room-display.component';

@Component({
  selector: 'app-booking-rooms-tab',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, BookingRoomDisplayComponent],
  templateUrl: './booking-rooms-tab.component.html'
})
export class BookingRoomsTabComponent {
  @Input() booking: IBookingModel | null = null;
  @Output() actionEvent = new EventEmitter<BookingActionEvent>();

  // Services
  readonly changeTracker = inject(BookingChangeTrackerService);
  private readonly logService = inject(LogService);

  /**
   * Handle field changes for a specific field
   * @param fieldName Name of the field that changed
   * @param newValue New value of the field
   */
  onFieldChange(fieldName: string, newValue: any): void {
    // Emit field change to parent component
    if (this.booking) {
      this.actionEvent.emit({
        action: 'field-change',
        booking: this.booking,
        additionalData: {
          fieldName,
          newValue
        }
      });
    }
  }
}
